/* ════════════════════════════════════════════════════════════════
   Iberluffa — Metadatos extendidos de producto
   Este archivo se carga DESPUÉS de site.js y enriquece el array
   SITE_PRODUCTS con campos largos (descripción, features, specs,
   gallery, stock, sizes, category). También define
   PRODUCT_CATEGORIES, usado en la ficha para el tab "Saber más
   sobre <categoría>".
   ════════════════════════════════════════════════════════════════ */

/* ── Defaults reutilizables ── */
const __PD_SHIP = 'Tiempo de entrega: 2-5 días.';
const __PD_ECO  = 'Producción eco-certificada por la UE.';
const __PD_FIB  = 'Fibras 100% naturales y completamente compostables.';

/* ── Galería: dado un id, devuelve la lista de "slots" de imagen.
   Slots reales (main, hover) primero, después placeholders rayados
   con un label que indica qué iría ahí. Esto deja la ficha
   visualmente completa sin inventar fotos que no existen. */
function __pdRes(p){ return (typeof window!=='undefined' && window.IB_RESOLVE) ? window.IB_RESOLVE(p) : p; }
/* i18n: traduce la etiqueta del placeholder vía window.IB_PD.ph (inyectado por
   iberluffa-i18n.liquid en inglés). En español devuelve la etiqueta tal cual. */
function __pdPh(label){ return (typeof window!=='undefined' && window.IB_PD && window.IB_PD.ph && window.IB_PD.ph[label]) || label; }
function __pdGallery(id, hasHover){
  // Imágenes REALES de Shopify (window.IB_GALLERY[id], inyectado por
  // iberluffa-shopify-data.liquid): 1ª = principal, el resto = galería de la ficha.
  const shop = (typeof window!=='undefined' && window.IB_GALLERY && window.IB_GALLERY[id]) || null;
  if(shop && shop.length){
    return shop.map(src => ({type:'img', src}));
  }
  // Fallback (producto sin imágenes en Shopify): imagen del diseño + placeholders.
  const real = [__pdRes(`assets/images/products/${id}.png`)];
  if(hasHover) real.push(__pdRes(`assets/images/products/hover/${id}.png`));
  return [
    ...real.map(src => ({type:'img', src})),
    {type:'placeholder', label:__pdPh('Vista detalle')},
    {type:'placeholder', label:__pdPh('En uso')},
  ];
}
function __pdGalleryFallback(label){
  return [
    {type:'img', src:__pdRes('assets/images/products/lufira.png')},
    {type:'placeholder', label:__pdPh('Vista frontal')},
    {type:'placeholder', label:__pdPh('Vista detalle')},
    {type:'placeholder', label:__pdPh('Contenido')},
  ];
}

/* ── Extras por producto ── */
const __PRODUCT_EXTRAS = {
  lufina: {
    description:'Esponja ovalada de luffa, 100% fibras compostables. Ideal para exfoliar, masajear y disfrutar del baño o la ducha. Producción con certificación ecológica de la UE.',
    features:[
      'Forma ovalada con cinta de lino para colgar.',
      'Exfoliación envolvente y suave para todo el cuerpo.',
    ],
    specs:[
      'Esponja ovalada de luffa con cinta de lino.',
      __PD_ECO, __PD_FIB,
      'Contenido: 1 esponja ovalada de luffa.',
      __PD_SHIP,
    ],
    category:'bano',
    gallery:__pdGallery('lufina', true),
  },
  lufira: {
    description:'Esponja de baño de luffa, hecha con fibras 100% naturales y compostables. Ideal para el cuidado diario: exfoliación suave, estimula la circulación y refresca la experiencia de baño y ducha.',
    features:[
      'Ideal para el cuidado diario: exfoliación suave, estimula la circulación.',
      'Uso para baño y ducha.',
    ],
    specs:[
      'Esponja de baño de luffa.',
      __PD_ECO, __PD_FIB,
      'Contenido: 1 esponja de baño de luffa, aprox. 12x12 cm.',
      __PD_SHIP,
    ],
    stock:47, category:'bano',
    gallery:__pdGallery('lufira', true),
  },
  laluf: {
    description:'Esponja de baño cuadrada de luffa, hecha con fibras 100% naturales y compostables. Ideal para el cuidado diario: exfoliación suave, estimula la circulación y refresca la experiencia de baño y ducha.',
    features:[
      'Ideal para el cuidado diario: exfoliación suave, estimula la circulación.',
      'Uso para baño y ducha.',
    ],
    specs:[
      'Esponja cuadrada de baño de luffa.',
      __PD_ECO, __PD_FIB,
      'Contenido: 1 esponja de baño de luffa, aprox. 12x12 cm.',
      __PD_SHIP,
    ],
    stock:32, category:'bano',
    gallery:__pdGallery('laluf', true),
  },
  lufio: {
    description:'Manopla de luffa para una exfoliación envolvente y profunda. Una alternativa natural a las manoplas sintéticas — masaje, espuma abundante y suavidad para tu piel.',
    features:[
      'Masaje envolvente y exfoliación profunda.',
      'Cómoda de sujetar — perfecta para todo el cuerpo.',
    ],
    specs:[
      'Manopla de baño de luffa.',
      __PD_ECO, __PD_FIB,
      'Contenido: 1 manopla, aprox. 16x10 cm.',
      __PD_SHIP,
    ],
    stock:23, category:'bano',
    gallery:__pdGallery('lufio', true),
  },
  sopura: {
    description:'Estuche de luffa para jabones: protege tu pastilla, la escurre y se compone con el resto de tu ritual. Sin plásticos, sin químicos, sólo fibra natural.',
    features:[
      'Drenaje perfecto — el jabón seca rápido y dura más.',
      'Compatible con la mayoría de pastillas del mercado.',
    ],
    specs:[
      'Estuche para jabones de luffa.',
      __PD_ECO, __PD_FIB,
      'Contenido: 1 estuche para jabón.',
      __PD_SHIP,
    ],
    stock:38, category:'bano',
    gallery:__pdGallery('sopura', true),
  },
  soaply: {
    description:'Soporte de luffa para tu jabón: drena el agua, alarga la vida útil del jabón y queda bonito en cualquier baño.',
    features:[
      'Drenaje natural por su estructura de fibras abiertas.',
      'Encaja con cualquier estética — minimalista y orgánico.',
    ],
    specs:[
      'Soporte para jabón de luffa.',
      __PD_ECO, __PD_FIB,
      'Contenido: 1 soporte para jabón.',
      __PD_SHIP,
    ],
    stock:54, category:'bano',
    gallery:__pdGallery('soaply', true),
  },
  peelux: {
    description:'Pack de discos exfoliantes de luffa diseñados para el cuidado facial y corporal. Exfoliación delicada, reutilizables, sin plástico y biodegradables.',
    features:[
      'Exfoliación suave y reutilizable.',
      'Ideal para rutinas faciales diarias.',
    ],
    specs:[
      'Discos exfoliantes de luffa.',
      __PD_ECO, __PD_FIB,
      'Contenido: 1 disco (a granel) o 3 discos (pack), aprox. 8 cm de diámetro.',
      __PD_SHIP,
    ],
    sizes:[
      {id:'granel', label:'A granel', sub:'1 disco',  price:1.85},
      {id:'pack3',  label:'Pack de 3', sub:'3 discos', price:5.50},
    ],
    stock:29, category:'bano',
    gallery:__pdGallery('peelux', true),
  },
  peelvita: {
    description:'Esponja de luffa con asas para llegar a la espalda y zonas difíciles. Exfoliación profunda, masaje circulatorio y aire libre para tu rutina diaria de ducha.',
    features:[
      'Asas resistentes — alcance perfecto en toda la espalda.',
      'Exfoliación profunda y revitalizante.',
    ],
    specs:[
      'Esponja con asas para espalda.',
      __PD_ECO, __PD_FIB,
      'Contenido: 1 esponja con asas, aprox. 40 cm.',
      __PD_SHIP,
    ],
    stock:6, category:'bano',
    gallery:__pdGallery('peelvita', true),
  },
  lufoo: {
    description:'Estropajo de luffa para tu cocina: limpia ollas, sartenes y superficies sin arañar. Sustituto natural a los estropajos sintéticos que liberan microplásticos.',
    features:[
      'Limpieza eficaz sin arañar superficies.',
      'Sin microplásticos — directo al compost al final de su vida útil.',
    ],
    specs:[
      'Estropajo multiusos de luffa.',
      __PD_ECO, __PD_FIB,
      'Contenido: 1 estropajo, aprox. 10x8 cm.',
      __PD_SHIP,
    ],
    stock:61, category:'hogar',
    gallery:__pdGallery('lufoo', true),
  },
  thegurk: {
    description:'La esponja de luffa todoterreno. Funciona en cocina, baño, cristales o jardinería. Una sola pieza, mil usos.',
    features:[
      'Una esponja, mil usos.',
      'Resistente y sostenible.',
    ],
    specs:[
      'Esponja multiusos de luffa.',
      __PD_ECO, __PD_FIB,
      'Contenido: 1 esponja multiusos.',
      __PD_SHIP,
    ],
    stock:41, category:'hogar',
    gallery:__pdGallery('thegurk', false),
  },
  'set-hombre': {
    description:'Estuche regalo con cuatro esponjas de luffa pensadas para el cuidado masculino diario: cuerpo, exfoliación, afeitado y jabonera.',
    features:[
      'Pack de 4 esponjas en estuche regalo.',
      'Listo para regalar — embalaje 100% reciclable.',
    ],
    specs:[
      'Set para hombre.',
      __PD_ECO, __PD_FIB,
      'Contenido: 4 piezas en estuche de cartón.',
      __PD_SHIP,
    ],
    stock:18, category:'sets',
    gallery:__pdGalleryFallback(),
  },
  'set-mujer': {
    description:'Estuche regalo con cuatro esponjas de luffa para una rutina completa de cuidado: facial, corporal, exfoliación y jabonera.',
    features:[
      'Pack de 4 esponjas en estuche regalo.',
      'Listo para regalar — embalaje 100% reciclable.',
    ],
    specs:[
      'Set para mujer.',
      __PD_ECO, __PD_FIB,
      'Contenido: 4 piezas en estuche de cartón.',
      __PD_SHIP,
    ],
    stock:21, category:'sets',
    gallery:__pdGalleryFallback(),
  },
  'pack-bodas': {
    description:'Pack de bodas con cuatro esponjas de luffa: el detalle perfecto, sostenible y memorable para tus invitados.',
    features:[
      'Pack de 4 esponjas en estuche regalo.',
      'Personalización disponible bajo petición.',
    ],
    specs:[
      'Pack para bodas.',
      __PD_ECO, __PD_FIB,
      'Contenido: 4 piezas en estuche regalo.',
      'Tiempo de entrega: 5-10 días.',
    ],
    stock:8, category:'sets',
    gallery:__pdGalleryFallback(),
  },
};

/* i18n: si window.IB_PD existe (idioma != es, inyectado por iberluffa-i18n.liquid),
   sobreescribe description/features/specs en inglés y las etiquetas de las sizes.
   gallery/category/stock/precio se conservan (no dependen del idioma). */
(function localizeExtras(){
  if(typeof window === 'undefined' || !window.IB_PD) return;
  if(window.IB_PD.extras){
    Object.keys(window.IB_PD.extras).forEach(function(id){
      if(__PRODUCT_EXTRAS[id]) Object.assign(__PRODUCT_EXTRAS[id], window.IB_PD.extras[id]);
    });
  }
  if(window.IB_PD.sizes && window.IB_PD.sizes.peelux && __PRODUCT_EXTRAS.peelux){
    __PRODUCT_EXTRAS.peelux.sizes = window.IB_PD.sizes.peelux;
  }
})();

/* Decora SITE_PRODUCTS in-place. site.js debe haberse cargado antes. */
(function enrichProducts(){
  if(typeof SITE_PRODUCTS === 'undefined') return;
  SITE_PRODUCTS.forEach(p => {
    const extra = __PRODUCT_EXTRAS[p.id];
    if(extra) Object.assign(p, extra);
    // Coletilla traducida (window.IB_COLETILLA inyectado por idioma); SITE_PRODUCTS
    // la tenía hardcodeada en español → la sobreescribimos con la del locale actual.
    if(window.IB_COLETILLA && window.IB_COLETILLA[p.id]) p.sub = window.IB_COLETILLA[p.id];
  });
})();

/* Fusiona los 3 SETS reales de Shopify (window.IB_SETS, inyectado por
   snippets/iberluffa-shopify-data.liquid) en SITE_PRODUCTS + __PRODUCT_EXTRAS para que
   sus fichas (/pages/producto?id=<themeId>) carguen. Las fichas de los 10 base ya
   funcionan con la maqueta; aquí solo se AÑADEN los sets que faltaban. */
(function mergeShopifySets(){
  if(typeof SITE_PRODUCTS === 'undefined' || typeof window === 'undefined' || !window.IB_SETS) return;
  Object.keys(window.IB_SETS).forEach(function(id){
    if(SITE_PRODUCTS.some(function(p){ return p.id === id; })) return; // ya existe
    var s = window.IB_SETS[id];
    var gallery = (s.images || []).slice(0, 4).map(function(src){ return {type:'img', src:src}; });
    if(!gallery.length) gallery = [{type:'placeholder', label:'Set'}];
    var __setFeat = (window.IB_PD && window.IB_PD.set_features) || ['Set de 4 piezas de luffa 100% natural.', 'Sostenible, sin plástico y compostable.'];
    var __setSpecs = (window.IB_PD && window.IB_PD.set_specs) || ['Set de luffa natural.', __PD_ECO, __PD_FIB, __PD_SHIP];
    __PRODUCT_EXTRAS[id] = {
      description: s.desc || '',
      features: __setFeat,
      specs: __setSpecs,
      category: 'sets',
      gallery: gallery,
    };
    var entry = {
      id: id, name: s.name, sub: s.sub, price: s.price, emoji: '🎁',
      handle: s.handle, variantId: s.vid, packSize: 4, packKind: 'Set',
    };
    Object.assign(entry, __PRODUCT_EXTRAS[id]);
    SITE_PRODUCTS.push(entry);
  });
})();

/* Fusiona los productos NUEVOS del cliente que no existen en la maqueta
   (window.IB_EXTRA, inyectado por snippets/iberluffa-shopify-data.liquid): hoy
   Lu Foot y El Camino. Mismo mecanismo que los sets, pero conservando su categoría
   real (pies / bano) y con noBundle:true → aparecen en catálogo, buscador, carrito
   y ficha, pero NO en "Crea tu pack". Datos (precio, fotos, texto) = los de Shopify,
   así el cliente los edita desde el admin. */
(function mergeShopifyExtra(){
  if(typeof SITE_PRODUCTS === 'undefined' || typeof window === 'undefined' || !window.IB_EXTRA) return;
  Object.keys(window.IB_EXTRA).forEach(function(id){
    if(SITE_PRODUCTS.some(function(p){ return p.id === id; })) return; // ya existe
    var s = window.IB_EXTRA[id];
    var gallery = (s.images || []).slice(0, 4).map(function(src){ return {type:'img', src:src}; });
    if(!gallery.length) gallery = [{type:'placeholder', label:s.name || ''}];
    __PRODUCT_EXTRAS[id] = {
      description: s.desc || '',
      features: s.features || [],
      // Las 3 líneas comunes (eco / fibras / envío) se reutilizan de IB_PD.set_specs,
      // que ya viene traducida por idioma; solo la 1ª es propia del producto.
      specs: [s.spec1].concat(
        (window.IB_PD && window.IB_PD.set_specs) ? window.IB_PD.set_specs.slice(1) : [__PD_ECO, __PD_FIB, __PD_SHIP]
      ).filter(Boolean),
      category: s.cat || 'bano',
      gallery: gallery,
      // Opciones del producto (talla de Lu Foot). Si tiene 2 o mas, el grid, el
      // buscador y la ficha piden elegir antes de anadir al carrito.
      sizes: (s.sizes && s.sizes.length >= 2) ? s.sizes : undefined,
    };
    var entry = {
      id: id, name: s.name, sub: s.sub, price: s.price, emoji: s.emoji || '🌿',
      handle: s.handle, variantId: s.vid, noBundle: true,
    };
    Object.assign(entry, __PRODUCT_EXTRAS[id]);
    SITE_PRODUCTS.push(entry);
  });
})();

/* ════════════════════════════════════════════════════════════════
   PRODUCT_CATEGORIES
   Contenido del tab "Saber más sobre <categoría>" en la ficha.
   Los productos de la categoría 'sets' NO muestran este tab
   (los packs no tienen "categoría" de la que aprender).
   ════════════════════════════════════════════════════════════════ */
const PRODUCT_CATEGORIES = {
  bano: {
    name:'Baño & Cuerpo',
    headline:'El Hada de la Espuma',
    short:'El Hada de la Espuma proporciona una exfoliación natural, dejando la piel suave y limpia. Suave pero eficaz, elimina las células muertas y estimula la circulación — una alternativa ecológica a las esponjas sintéticas, sostenible y beneficiosa para la piel.',
    sections:[
      {
        kicker:'Uso y cuidado',
        title:'Para el cuerpo y el alma',
        body:'El Hada de la Espuma mima la piel con una exfoliación suave, un masaje relajante y una abundante espuma. Estimula la circulación y deja una sensación refrescante en la piel, ideal para el baño, la ducha y el frotado en seco. Ya sea en húmedo o en seco, revitaliza el cuerpo y la mente y deja que el alma se relaje.',
      },
      {
        title:'Fácil mantenimiento',
        body:'Gracias a sus fibras abiertas y su lazo para colgar, se seca rápidamente y permanece higiénico. Para limpiarlo, simplemente mételo en el lavavajillas o hiérvelo ocasionalmente.',
        image:'assets/images/mision/mision-luffa.jpg',
      },
      {
        title:'Eliminación sostenible',
        body:'Cuando ya no sirva, puede ir al contenedor de residuos orgánicos o al compost — ¡de vuelta a la naturaleza!',
      },
      {
        kicker:'¡Bien por ti y por el medio ambiente!',
        title:'Las primeras luffas con certificación ECO del mercado',
        body:'Hecho a mano y único, sin aditivos químicos, ecológico desde el cultivo hasta el producto final. Las esponjas y el embalaje cierran el ciclo natural. Iberluffa está especialmente orgullosa de ser la primera y única empresa en ofrecer esponjas de luffa con certificación ECO en su producción.',
        image:'assets/images/hero/hero-desktop-ae88b496.jpg',
      },
    ],
  },
  cuerpo: {
    name:'Exfoliación',
    headline:'Exfoliación que se siente bien',
    short:'La exfoliación natural con luffa renueva la piel sin químicos. Una pieza, un gesto, una rutina sostenible que se nota al instante.',
    sections:[
      {
        kicker:'Un ritual diario',
        title:'Exfoliar sin agredir',
        body:'La exfoliación con luffa estimula la microcirculación, elimina las células muertas y deja la piel preparada para absorber mejor cremas y aceites. No agrede — acaricia. Ideal para rutinas faciales y corporales.',
      },
      {
        title:'Cuidado de tus discos',
        body:'Después de cada uso, enjuaga y deja secar al aire. Cuando se sientan saturados, mételos en el lavavajillas o hiérvelos para revivir las fibras.',
        image:'assets/images/mision/mision-luffa.jpg',
      },
      {
        title:'Cuando termine su vida útil',
        body:'Directo al contenedor orgánico — sin restos plásticos, sin culpas. La naturaleza recupera lo suyo.',
      },
    ],
  },
  hogar: {
    name:'Hogar & Limpieza',
    headline:'La cocina también respira',
    short:'Los estropajos de luffa limpian sin liberar microplásticos. Resistentes, eco-certificados y compostables al final de su vida útil — una alternativa real a los estropajos sintéticos.',
    sections:[
      {
        kicker:'Una elección real',
        title:'Limpieza eficaz, sin microplásticos',
        body:'Los estropajos sintéticos liberan diminutos fragmentos plásticos en cada uso que terminan en océanos y en nuestra comida. La luffa, no. Cero microplásticos, fibras naturales y misma eficacia.',
      },
      {
        title:'Cómo mantenerlos',
        body:'Tras el uso, escurre bien y deja secar colgado. Para desinfectar, lavavajillas o agua hirviendo. Sus fibras vuelven a la vida.',
        image:'assets/images/mision/mision-luffa.jpg',
      },
      {
        title:'Fin de ciclo natural',
        body:'Cuando se desgastan, al compost. De la tierra vinieron, a la tierra vuelven — sin residuos.',
      },
    ],
  },
  pies: {
    name:'Para tus pies',
    headline:'Cuidado de pies, sin químicos',
    short:'Esponjas y piedras de luffa pensadas para los pies: exfoliación de zonas duras, masaje circulatorio y descanso real al final del día.',
    sections:[
      {
        title:'Cuidado profundo, sin agresión',
        body:'La textura firme de la luffa elimina la piel dura sin las heridas microscópicas de las piedras pómez sintéticas. Ducha, secado y un par de minutos al día son suficientes.',
      },
      {
        title:'Mantenimiento sencillo',
        body:'Enjuaga, deja secar al aire. De vez en cuando, agua hirviendo para refrescar las fibras.',
      },
    ],
  },
};

/* i18n: sobreescribe el contenido de las categorías (name/headline/short/sections)
   en inglés desde window.IB_PD.cats. Las rutas de imagen se resuelven después. */
(function localizeCategories(){
  if(typeof window === 'undefined' || !window.IB_PD || !window.IB_PD.cats) return;
  Object.keys(window.IB_PD.cats).forEach(function(cat){
    if(PRODUCT_CATEGORIES[cat]) Object.assign(PRODUCT_CATEGORIES[cat], window.IB_PD.cats[cat]);
  });
})();

/* Resolver rutas de imagen de las secciones de categoría a assets del tema. */
(function __resolveCatImages(){
  if(typeof window==='undefined' || !window.IB_RESOLVE) return;
  Object.values(PRODUCT_CATEGORIES).forEach(c => {
    (c.sections||[]).forEach(s => { if(s.image) s.image = window.IB_RESOLVE(s.image); });
  });
})();
